import { Box, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import { theme } from '../../theme/theme';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import FacebookIcon from '@mui/icons-material/Facebook';
// import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import ImageComponent from '../Image/Image';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

const SOCIALS = [
  {
    icon: FacebookIcon,
    href: 'https://www.facebook.com/',
    color: '#4267B2'
  },
  {
    icon: TwitterIcon,
    href: 'https://x.com/',
    color: '#000'
  },
  {
    icon: LinkedInIcon,
    href: 'https://www.linkedin.com/',
    color: '#0A66C2'
  },
  {
    icon: InstagramIcon,
    href: 'https://www.instagram.com/',
    color: '#F56040'
  }
];

const StyledLink = styled(Link)`
  color: ${theme.palette.primary.footer};
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: 0.2s all;
  &:hover {
    color: ${theme.palette.primary.light};
  }
`;

const Footer = () => {
  const { t } = useTranslation();

  const outerBox = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: '32px'
  };

  const innerBox = {
    display: 'flex',
    flexGrow: 1,
    gap: '20px',
    flexDirection: 'column '
  };

  const iconStyle = {
    mr: 1,
    fontSize: '16px',
    color: '#202020',
    cursor: 'pointer'
  };

  const getSocialIconStyle = (color) => ({
    ...iconStyle,
    fontSize: '18px',
    transition: '.3s ease-in',
    color: '#666',
    '&:hover': {
      color: color ?? '#3F63EC'
    }
  });

  return (
    <Box
      sx={{
        borderTop: '1px solid #d4d4d4'
      }}>
      <Container maxWidth="xl">
        <Box>
          <Box sx={outerBox}>
            <Grid
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                rowGap: 2,
                columnGap: 2
              }}
              container>
              <Grid xs={12} sm={12} md={4} lg={2.3}>
                <Box sx={innerBox}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: 'none',
                      fontSize: '16px',
                      fontWeight: 500,
                      color: theme.palette.primary.footer
                    }}>
                    <ImageComponent name="logo" height={30} alt="HOME AI Logo" />
                  </Link>
                </Box>
              </Grid>

              <Grid xs={6} sm={6} md={4} lg={1.3}>
                <Box sx={innerBox}>
                  {/* <StyledLink to="/tenants">{t('For Tenants')}</StyledLink> */}
                  {/* <Link to="/owners" duration={500} style={linkStyle}>
                  {t("For Owners")}
                </Link> */}
                  <StyledLink to="/features">{t('Features')}</StyledLink>
                  <StyledLink to="/contact-us">{t('Contact Us')}</StyledLink>
                </Box>
              </Grid>
              <Grid xs={6} sm={6} md={4} lg={1.3}>
                <Box sx={innerBox}>
                  <StyledLink to="/plan">{t('Pricing')}</StyledLink>
                  <StyledLink to="/blog-list">{t('Blog')}</StyledLink>
                </Box>
              </Grid>
              {/* <Grid xs={12} sm={6} md={4} lg={1.3}>
              <Box sx={innerBox}>
                <Link to="/about-us" style={linkStyle}>
                  {t("About Us")}
                </Link> 
              </Box>
            </Grid> */}
              <Grid xs={12} sm={6} md={4} lg={1.3}>
                <Box sx={innerBox}>
                  <StyledLink to="/faq">{t('FAQ')}</StyledLink>
                </Box>
              </Grid>

              <Grid xs={12} sm={6} md={4} lg={2}>
                <Box
                  sx={{
                    ...innerBox,
                    gap: '5px',
                    display: 'flex',
                    justifyContent: 'flex-end'
                  }}>
                  <Typography
                    sx={{
                      fontSize: 16,
                      color: 'black',
                      fontWeight: 500,
                      cursor: 'auto'
                    }}>
                    {t('Have questions?')}
                  </Typography>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <EmailIcon sx={{ ...iconStyle, cursor: 'auto' }} />
                    <StyledLink to="mailto:contact@homeai.ch">contact@homeai.ch</StyledLink>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <PhoneIcon sx={{ ...iconStyle, cursor: 'auto' }} />
                    <StyledLink to="tel:0793054286">0793054286</StyledLink>
                  </Box>

                  {/* <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mt: 2
                    }}>
                    <Typography sx={{ ...linkStyle, mr: 1, fontSize: '14px', cursor: 'auto' }}>
                      {t('Follow Us:')}
                    </Typography>
                    {SOCIALS.map(({ color, href, icon: Icon }) => (
                      <a href={href} target="_black">
                        <Icon sx={{ ...getSocialIconStyle(color) }} />
                      </a>
                    ))}
                  </Box> */}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          // backgroundColor: theme.palette.background.lightBlue,
          borderTop: '1px solid #ddd',
          height: '50px',
          gap: 2
        }}>
        <Container maxWidth="xl">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
            <Box
              sx={{
                [theme.breakpoints.down('sm')]: {
                  display: 'none'
                }
              }}>
              <Typography
                noWrap={true}
                sx={{
                  fontSize: '12px'
                }}>
                {t('© Copyright 2024, All Rights Reserved')}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                color: theme.palette.primary,
                rowGap: 0.5,
                columnGap: 2,
                flexWrap: 'wrap'
              }}>
              <StyledLink to="/search-property" style={{ fontSize: '12px' }}>
                {t('Search Property')}
              </StyledLink>
              <StyledLink to="/privacy-policy" style={{ fontSize: '12px' }}>
                {t('Privacy Policy')}
              </StyledLink>
              <StyledLink to="/terms-and-conditions" style={{ fontSize: '12px' }}>
                {t('Terms and Conditions')}
              </StyledLink>
              <StyledLink to="/support" style={{ fontSize: '12px' }}>
                {t('Support')}
              </StyledLink>
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;
